module.exports = __webpack_public_path__ + "img/breakfast_available.68ff1698.jpg";